import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setFieldsState } from '../../../actions/fieldsState';
import { FormField } from '../../../components/FormField';
import { PriceInput } from '../../../components/PriceInput';
import { selectMoneyToSpend } from '../../../selectors/moneyToSpend';
import { TThunkDispatch } from '../../../types/redux/thunk';

export const MoneyToSpend: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const moneyToSpend = useSelector(selectMoneyToSpend);

  const handleChange = React.useCallback(
    (value: number | null) => {
      dispatch(setFieldsState({ moneyToSpend: value }));
    },
    [dispatch],
  );

  return (
    <FormField
      label="Сколько готовы платить за ипотеку в месяц?"
      description="Сумма, которая остаётся после всех трат, включая аренду"
      data-name="MoneyToSpendFormField"
    >
      <PriceInput value={moneyToSpend} onChange={handleChange} />
    </FormField>
  );
};
